import { createContext, useContext } from 'react';

interface PlacematContextValue {
  activeSlot: string | null;
  slotFieldName: string | null;
  setActiveSlot: (slot: string | null) => void;
}

export const PlacematContext = createContext<PlacematContextValue>({
  activeSlot: null,
  slotFieldName: null,
  setActiveSlot: () => {},
});

export const usePlacematContext = () => useContext(PlacematContext);
